// extracted by mini-css-extract-plugin
export default {"CommentListPlaceholder":"if_a bhc_ji","CommentListPlaceholder--Legacy":"if_b bhc_ra bhc_wo"};